<template>
  <div class="modal p-0 js-modal fade plplp-modal"
       id="plplp-modal"
       aria-modal="true"
       role="dialog">
    <div class="modal-dialog modal-full-screen">
      <div class="modal-content">
        <confirmation-alert-modal v-if="this.modal.type === 'confirmation-alert'"/>
        <travel-status-modal v-if="this.modal.type === 'travel-status'"/>
        <select-city-modal v-if="this.modal.type === 'select-city'" :origin="this.origin"/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import confirmationAlertModal from './components/modals/confirmationAlertModal.vue';
import travelStatusModal from './components/modals/travelStatusModal.vue';
import selectCityModal from './components/modals/selectCityModal.vue';

export default {
  props: [
    'origin'
  ],
  computed: {
    ...mapState([
      'modal'
    ])
  },
  methods: {
    ...mapActions([
      'setModal'
    ])
  },
  components: {
    confirmationAlertModal: confirmationAlertModal,
    travelStatusModal: travelStatusModal,
    selectCityModal: selectCityModal
  },
  updated() {
    if (Object.keys(this.modal).length !== 0) {
      $(this.$el).modal('show');
    }
  },
  mounted: function () {
    $(this.$el).on('hidden.bs.modal', () => {
      this.setModal({});
    });
  }
}
</script>
